import React, { useState } from 'react';
import ModalNew from '../../../../../components/ui/popup/Modal';
import { PopupContent, PopupHeader } from '../../../../../components/ui/popup/common';

const EfileStateUpdateModal = ({ 
  isOpen, 
  onClose, 
  service, 
  initialNumber, 
  onUpdate 
}) => {
  const [number, setNumber] = useState(initialNumber || "");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = () => {
    setNumber("");
    setReason("");
    setSuccess(false);
    onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    const result = await onUpdate({
      service,
      state: parseInt(number, 10),
      reason: reason.trim()
    });
    
    setLoading(false);
    if (result) setSuccess(true);
  };

  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal" style={{ maxWidth: "480px" }}>
      {!success && (
        <PopupHeader
          title="Efile State Number"
          setOpenState={handleClose}
          icon={`${process.env.PUBLIC_URL}/images/icons/news_blue_popup.svg`}
          variant="compact"
        />
      )}
      <PopupContent>
        {success ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <span className="mFont" style={{ fontSize: "48px", color: "#83b50d", display: "block", marginBottom: "16px" }}>
              check_circle
            </span>
            <p style={{ fontSize: "16px", color: "#1A2127", marginBottom: "24px" }}>
              Efile State number for {service} updated successfully!
            </p>
            <button type="button" className="cta-button primary short text-center" onClick={handleClose}>
              Close
            </button>
          </div>
        ) : loading ? (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <div className="loading-spinner" style={{ marginBottom: "16px" }}></div>
            <p style={{ fontSize: "14px", color: "#666B6F" }}>Updating Efile State...</p>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: "#1a2127" }}>
                New Efile State Number
              </label>
              <input
                type="number"
                min="0"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                className="form-input"
                style={{ width: "100%" }}
                placeholder="Enter the new number"
              />
            </div>
            <div style={{ marginBottom: "24px" }}>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: "#1a2127" }}>
                Reason for Update
              </label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Explain why the update is needed (e.g., Reciprocity)"
                style={{ width: "100%", minHeight: "100px", padding: "8px", border: "1px solid #e0e0e0", borderRadius: "4px", fontSize: "14px" }}
              />
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
              <button type="button" className="cta-button secondary short text-center" onClick={handleClose}>
                Cancel
              </button>
              <button
                type="button"
                className="cta-button primary short text-center"
                onClick={handleSubmit}
                disabled={!number || !reason.trim()}
              >
                Update
              </button>
            </div>
          </>
        )}
      </PopupContent>
    </ModalNew>
  );
};

export default EfileStateUpdateModal;